class ImageComponent extends HTMLElement {
  constructor() {
    super();
    this.imgElement = document.createElement('img');
  }

  static get observedAttributes() {
    return ['src', 'class', 'className'];
  }

  getRealSrcPath(src: string) {
    if (src.indexOf('assets://') !== -1) {
      const newPath = src.replace('assets://', process.env.AWP_DEPLOY_ENV ? `${process.env.PUBLIC_PATH}${process.env.FOLDER}/assets/` : `${process.env.PUBLIC_PATH}assets/`);
      return newPath;
    } else {
      return src;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === 'src') && (oldValue !== newValue)) {
      this.imgElement.src = this.getRealSrcPath(newValue);
    } else if ((name === 'class' || name === 'className') && (oldValue !== newValue)) {
      this.imgElement.className = newValue;
    }
  }

  connectedCallback() {
    this.appendChild(this.imgElement);
    this.updateImage();
  }

  updateImage() {
    this.imgElement.src = this.getRealSrcPath(this.getAttribute('src'));
    this.imgElement.className = this.getAttribute('class') || this.getAttribute('className');
  }
}
export default ImageComponent;